export default __webpack_public_path__ + "static/media/error.1164a277.svg";